module.exports = __webpack_public_path__ + "static/media/ic_unlock_hover.7c540fef.svg";